// @flow
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useRequestOrgAccessMutation } from '@streaming-projects/service-definitions/streamingProjectsApi';
import { ConfirmModal } from '@presentational/modals/ConfirmModal';
import { toastError, toastSuccess } from '@presentational/notifications/utils';
import { getLinkForStreamingProjectsHomePage } from '@streaming-projects/links';

export const SPORGRequestModal = ({ isOpen, setOpen, orgId }) => {
  const header = `You do not have access to this ORG`;
  const [requestOrgAccessFunc] = useRequestOrgAccessMutation();
  const { push } = useHistory();

  return (
    <ConfirmModal
      body={<p>Request access?</p>}
      centered={false}
      header={header}
      isOpen={isOpen}
      okButtonText="Request"
      onClickHandlerForCancel={() => {
        setOpen(false);
        push(getLinkForStreamingProjectsHomePage());
      }}
      onClickHandlerForOK={async () => {
        const { error } = await requestOrgAccessFunc({ orgId });
        if (error) {
          toastError(error);
        } else {
          toastSuccess(
            'Requested for access! A slack notification was sent to the owner regarding your request!'
          );
        }
        setOpen(false);
        push(getLinkForStreamingProjectsHomePage());
      }}
    />
  );
};
